import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { history } from 'store/configureStore';
import { AmplifyAuthenticator, AmplifySignIn } from '@aws-amplify/ui-react';
// スタイル
import * as style from 'styles/util';
import { Container, Row } from 'react-bootstrap';

// パーツコンポーネント
import Header     from 'components/parts/header';
import Breadcrumb from 'components/parts/breadcrumb';
import Sidebar    from 'components/parts/sidebar';

// ページ
// ページ
import AdmAccounts          from 'components/adm/account';
import AdmAccountRegist     from 'components/adm/account/regist';
import AdmAccountDetail     from 'components/adm/account/detail';
import AdmAccountEdit       from 'components/adm/account/edit';
import SrvFiles             from 'components/srv/file';
import SrvVersionDetail     from 'components/srv/file/version/detail';
import SrvVersionEdit       from 'components/srv/file/version/edit';
import SrvProgramSettings   from 'components/srv/setting';
import SrvProgramRegist     from 'components/srv/setting/regist';
import SrvProgramDetail     from 'components/srv/setting/detail';
import SrvProgramEdit       from 'components/srv/setting/edit';
import Start                from 'components/start';

const WithAuth = (
  () => (
    <AmplifyAuthenticator>
      <AmplifySignIn
        slot="sign-in"
        hideSignUp={true}
      >
      </AmplifySignIn>
      <style.Wrapper>
        <Header />
        <Breadcrumb />
        <Container fluid>
          <Row>
            <Sidebar />
            <ConnectedRouter history={history}>
              {/* 各種認証の必要な画面 */}
              <Switch>
                {/* ログイン直後の画面（リダイレクト用） */}
                <Route exact path='/start'                 component={Start} />
                {/* 管理者アカウント一覧画面 */}
                <Route exact path='/adm/accounts'          component={AdmAccounts} />
                {/* 管理者アカウント登録画面 */}
                <Route exact path='/adm/account/regist'    component={AdmAccountRegist} />
                {/* 管理者アカウント詳細画面 */}
                <Route exact path='/adm/account/detail/:id'component={AdmAccountDetail} />
                {/* 管理者アカウント編集画面 */}
                <Route exact path='/adm/account/edit/:id'  component={AdmAccountEdit} />
                {/* プログラムファイル一覧画面 */}
                <Route exact path='/srv/files'             component={SrvFiles} />
                {/* バージョン詳細画面 */}
                <Route exact path='/srv/version/detail/:id'component={SrvVersionDetail} />  
                {/* バージョン更新画面 */}
                <Route exact path='/srv/version/edit/:id'  component={SrvVersionEdit} />
                {/* 調整プログラム一覧画面 */}
                <Route exact path='/srv/settings'          component={SrvProgramSettings} />
                {/* 調整プログラム登録画面 */}
                <Route exact path='/srv/setting/regist'    component={SrvProgramRegist} />
                {/* 調整プログラム詳細画面 */}
                <Route exact path='/srv/setting/detail/:id'component={SrvProgramDetail} />
                {/* 調整プログラム編集画面 */}
                <Route exact path='/srv/setting/edit/:id'  component={SrvProgramEdit} />
              </Switch>
            </ConnectedRouter>
          </Row>
        </Container>
      </style.Wrapper>
    </AmplifyAuthenticator>
  )
);

const WithAuthRoutes = props => {
  return <WithAuth {...props} />;
};

export default WithAuthRoutes;